export default __webpack_public_path__ + "files/1_3_3_Draft_Bioeconomy_Strategy_Nitra_Region_Slovakia.docx";